import styled from 'styled-components';

export const ParticipantsWrapper = styled.div``;

export const ParticipantsLabel = styled.span`
  color: ${({ theme }) => theme.color.text.secondary};
`;
